/**
 * src/components/hero/HeroContent.js
 *
 * Columna izquierda del hero: headline, subtítulo, CTAs y stats de confianza.
 * Props: { headline, subheadline, ctas, trust }
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('HeroContent', ({ headline, subheadline, ctas, trust = [] }) => {
    const trustItems = trust.map(({ value, label }) =>
        h('div', { className: 'hero-trust__item' },
            h('strong', { className: 'hero-trust__value' }, value),
            h('span',   { className: 'hero-trust__label' }, label)
        )
    )

    return h('div', { className: 'hero-content' },
        h('h1', { className: 'hero-content__headline' }, headline),
        h('p',  { className: 'hero-content__sub' }, subheadline),
        c('HeroCTAs', { ctas }),
        h('div', { className: 'hero-trust' }, ...trustItems)
    )
})
